import { render } from "./uploadFingerPrint.vue?vue&type=template&id=25de5eb7&scoped=true"
import script from "./uploadFingerPrint.vue?vue&type=script&lang=js"
export * from "./uploadFingerPrint.vue?vue&type=script&lang=js"

import "./uploadFingerPrint.vue?vue&type=style&index=0&id=25de5eb7&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25de5eb7"]])

export default __exports__